var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModal", {
        attrs: { titulo: "Ver Detalle Recepción de Información" },
        on: { cerrar: _vm.handleCerrar }
      }),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos, "validar-paso": false },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c(
        "ContenidoModal",
        [
          _c("RecepcionActividadForm", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.pasoActivoIndex === _vm.pasos.informacionGeneral.step,
                expression: "pasoActivoIndex === pasos.informacionGeneral.step"
              }
            ],
            attrs: {
              disabled: true,
              "recepcion-actividad": _vm.recepcionActividad,
              "test-id": "VerDetalleRecepcionActividadModal"
            }
          }),
          _c("AsociarFlotaEtiquetaVehiculoIndividual", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pasoActivoIndex === _vm.pasos.asociarVehiculos.step,
                expression: "pasoActivoIndex === pasos.asociarVehiculos.step"
              }
            ],
            attrs: {
              readonly: true,
              "flotas-id-seleccionar":
                _vm.recepcionActividadDetalle &&
                _vm.recepcionActividadDetalle.flotasId,
              "etiquetas-id-seleccionar":
                _vm.recepcionActividadDetalle &&
                _vm.recepcionActividadDetalle.etiquetasId,
              "vehiculos-id-seleccionar":
                _vm.recepcionActividadDetalle &&
                _vm.recepcionActividadDetalle.vehiculosId,
              "col-def-vehiculo": _vm.vehiculoColDefs,
              filtroGps: true
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }